/* eslint-disable multiline-ternary */
/* eslint-disable max-len */
/* eslint-disable require-jsdoc */
import React, { useEffect, useState, lazy } from 'react'
import AppRoutesUnauthorized from './AppRoutesUnauthorized'
// import { Layout } from './components/Layout'
import './custom.css'
import ReactGA from './utils/reactGa'
import RouteChangeTracker from './components/RouteChangeTracker'
import { useAuth } from './contexts/AuthContext.jsx'
import useIdle from './hooks/useIdleTimeout'
import BasicLayout from './layouts/BasicLayout'
const DashboardLayoutBasic = lazy(() => import('./components/dashboard/DashboardLayoutBasic'))
const AppRoutes = lazy(() => import('./AppRoutes'))

const App = () => {
  ReactGA.initialize('G-WSQHC5C2E3')
  const [userRole, setUserRole] = useState(null)
  const { user, isAuthenticated } = useAuth()
  // eslint-disable-next-line no-unused-vars
  const { idleTimer } = useIdle({ idleTime: 5 })

  useEffect(() => {
    const fetchUserRole = async () => {
      if (user?.roles[0]) {
        setUserRole(user?.roles[0])
        ReactGA.set({
          user_id: user?.userId,
          user_role: user?.roles[0]
        })
      }
    }
    fetchUserRole()
  }, [user])

  return (
    <>
      {isAuthenticated ? (
        <DashboardLayoutBasic>
          <RouteChangeTracker />
          <AppRoutes userRole={userRole} />
        </DashboardLayoutBasic>
      ) : (
        // Render unauthenticated layout or redirect to login
        <BasicLayout>
          <RouteChangeTracker />
          <AppRoutesUnauthorized />
        </BasicLayout>
      )}
    </>
  )
}

export default App
